"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allowOverwrite = allowOverwrite;
exports.forceCurry = forceCurry;
exports.mergeComplexProps = mergeComplexProps;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function allowOverwrite(curriedProps, props) {
  return _objectSpread({}, curriedProps, {}, props);
}

function forceCurry(curriedProps, props) {
  return _objectSpread({}, props, {}, curriedProps);
}

var unique = function unique(array) {
  return Array.from(new Set(array));
};

function getAllPropNames(curriedProps, props) {
  return unique([].concat(_toConsumableArray(Object.keys(curriedProps)), _toConsumableArray(Object.keys(props))));
}

function mergeObjects() {
  var curriedProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isHard = arguments.length > 2 ? arguments[2] : undefined;
  return isHard ? _objectSpread({}, prop, {}, curriedProp) : _objectSpread({}, curriedProp, {}, prop);
}

function mergeDefault(curriedProp, prop, isHard) {
  return isHard ? curriedProp || prop : prop || curriedProp;
}

function mergeClasses() {
  var curriedProp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return "".concat(curriedProp, " ").concat(prop).trim();
}

function throwCombinedError() {
  for (var _len = arguments.length, errors = new Array(_len), _key = 0; _key < _len; _key++) {
    errors[_key] = arguments[_key];
  }

  var actualErrors = errors.filter(function (error) {
    return error instanceof Error;
  });

  if (actualErrors.length === 0) {
    return;
  }

  if (actualErrors.length === 1) {
    throw actualErrors[0];
  }

  throw new Error(actualErrors.map(function (error) {
    return error.message;
  }).join(" "));
}

function mergeHandlers(curriedProp, prop) {
  if (curriedProp && prop) {
    return function () {
      var curryError = undefined;
      var otherError = undefined;

      try {
        prop.apply(void 0, arguments);
      } catch (error) {
        otherError = error;
      }

      try {
        curriedProp.apply(void 0, arguments);
      } catch (error) {
        curryError = error;
      }

      throwCombinedError(curryError, otherError);
    };
  }

  return curriedProp || prop;
}

function getMergeStrategy(propName) {
  if (propName === "className") {
    return mergeClasses;
  }

  if (propName.match(/^on[A-Z]/)) {
    return mergeHandlers;
  }

  if (propName === "style") {
    return mergeObjects;
  }

  return mergeDefault;
}

function mergeComplexProps(curriedProps, props, isHard) {
  var resultProps = {};
  getAllPropNames(curriedProps, props).forEach(function (propName) {
    var curriedProp = curriedProps[propName];
    var prop = props[propName];
    var merge = getMergeStrategy(propName);
    resultProps[propName] = merge(curriedProp, prop, isHard);
  });
  return resultProps;
}